/* eslint-disable i18next/no-literal-string */
export const InfinitiSamplerEmblem = ({ horizontal }: { horizontal?: boolean }) => {
  return (
    <div className='relative flex h-full flex-grow p-12'>
      {horizontal ? (
        <div className='flex items-center gap-8'>
          <svg fill='none' height='19' viewBox='0 0 12 19' width='12' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 0H4.01798V19H0V0Z' fill='black' fill-opacity='0.4' />
            <path d='M7.98202 0H12V19H7.98202V0Z' fill='black' fill-opacity='0.4' />
          </svg>
          <div className='flex flex-col'>
            <p className='sb-logo-text f-ui-02 mb-0 text-lightest'>ELEVENLABS</p>
            <p className='sb-logo-text f-ui-02 mb-0 text-lightest'>AI INFINITE SAMPLER</p>
          </div>
        </div>
      ) : (
        <>
          <svg fill='none' height='16' viewBox='0 0 10 16' width='10' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 0H3.21033V15.7355H0V0Z' fill='#D7D7D7' />
            <path d='M6.37756 0H9.58789V15.7355H6.37756V0Z' fill='#D7D7D7' />
          </svg>
          <div className='ml-auto flex'>
            <p
              className='f-ui-02 text-lightest opacity-50'
              style={{ writingMode: "vertical-rl", textOrientation: "mixed" }}
            >
              ELEVENLABS
            </p>
            <p
              className='f-ui-02 text-lightest opacity-50'
              style={{ writingMode: "vertical-rl", textOrientation: "mixed" }}
            >
              INFINITE SAMPLER
            </p>
          </div>
        </>
      )}
    </div>
  );
};
